const columnColors = {
  status: {
    pending: 'warning.main',
    accepted: 'success.main',
    declined: 'error.main'
  }
};

module.exports = columnColors;
